import * as yup from 'yup';

export const perfectPaySchema = yup.object().shape({
  access_token: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(11, 'Informe um access token válido.'),
  provider_id: yup.string().required('Este campo é obrigatório.'),
});
